<template>
<div class="chapter">
<div class="inner_page">
<p class="dedication"><a id="page_vii"></a><em>For my parents, Jan and George,<br/>who gave me my adventurous palate and always<br/>encouraged my vivid imagination and passion<br/>for the written word.</em></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?a6b92a7a